// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

import {
    CancellationEventArgsBase,
} from "./CancellationEventArgsBase.js";

/**
 * Defines content of a MeetingTranscriptionCanceledEvent.
 * @class MeetingTranscriptionCanceledEventArgs
 */
export class MeetingTranscriptionCanceledEventArgs extends CancellationEventArgsBase {
}
